import { AxiosError, AxiosResponse } from 'axios';

export type TApiContactsLocation = {
  title: string;
};

export type TApiContactsGroup = {
  title: string;
};

export type TApiContactsEntity = {
  id: number;
  name: string;
  email: string;
  position: string;
  phoneNumber: string;
  profilePhotoUrl?: string | null;
  accessibleLocations: Array<TApiContactsLocation>;
  accessibleDepartments: Array<TApiContactsGroup>;
}

export interface TContactsState {
  readonly loading?: boolean;
  readonly data?: Array<TApiContactsEntity>;
  readonly filteredList?: Array<TApiContactsEntity>;
  readonly searchPhrase?: string;
  readonly searchLocation?: string;
  readonly searchGroup?: string;
}

export const initialContactsState: TContactsState = {
  loading: false,
  data: undefined,
}

export enum GetContactsList {
  REQUEST = 'GET_CONTACTS_LIST_REQUEST',
  SUCCESS = 'GET_CONTACTS_LIST_SUCCESS',
  FAILED = 'GET_CONTACTS_LIST_FAILED',
}

export type TGetContactsListAction =
  | {
  type: GetContactsList.REQUEST;
}
  | {
  type: GetContactsList.SUCCESS;
  payload: AxiosResponse<{ contacts: Array<TApiContactsEntity>; profilePhotoUrls: Record<number, string | null> }>;
}
  | {
  type: GetContactsList.FAILED;
  payload: AxiosError;
};

export enum FilterContactsList {
  SUBMIT = 'FILTER_CONTACTS_LIST',
}

export type TFilterContactsListActionPayload = {
  search: string;
  location: string;
  group: string;
};

export type TFilterContactsListAction = {
  type: FilterContactsList.SUBMIT;
  payload: TFilterContactsListActionPayload;
};

export type TContactActions =
  | TGetContactsListAction
  | TFilterContactsListAction;